import { PRODUCT_TYPES } from '../utils/constants';

const getProductType = (customFields = []) => {
  const fields = customFields.reduce((acc, field) => {
    const { name, value } = field.node || field;
    acc[name] = value;
    return acc;
  }, {});

  const { tipo, pesokg } = fields;
  const type = tipo?.toLowerCase();

  if (type === 'kg' && !!pesokg) return PRODUCT_TYPES.PIECE_KILO;
  if (type === 'kg') return PRODUCT_TYPES.KILOGRAM;
  return PRODUCT_TYPES.PIECE;
};

export default getProductType;
